// extracted by mini-css-extract-plugin
export default {"Modal":"DashboardComparisonModal_Modal__ZI0ga","Avatar":"DashboardComparisonModal_Avatar__xHRj+"};